import {
  apiRoutes,
  httpClient,
  type DefaultQueryError,
  type User,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const getUserProfileFn = async () => {
  const response = await httpClient.get<User>(apiRoutes.user.profile);
  return response.data;
};

export const useGetUserProfile = (
  opts?: Omit<UseQueryOptions<User, DefaultQueryError>, 'queryKey'>
) =>
  useQuery<User, DefaultQueryError>({
    queryKey: [apiRoutes.user.profile],
    queryFn: getUserProfileFn,
    ...opts,
  });
